import { makeOptionsFromPropertyWithoutBlankOptions } from 'customer-data-property-utils/PropertyValueDisplay';
import UISelect from 'UIComponents/input/UISelect';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { getPaymentStatusAvatar } from '../formatted/FormattedPaymentStatus';
import { memo } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputPaymentStatus = ({
  autoFocus,
  buttonUse,
  className,
  inputRef,
  onChange,
  property,
  readOnly,
  value,
  disabled
}) => {
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  const statusOptions = makeOptionsFromPropertyWithoutBlankOptions(property).map(option => Object.assign({}, option, {
    avatar: getPaymentStatusAvatar(option.value)
  }));
  return /*#__PURE__*/_jsx(UISelect, {
    autoFocus: autoFocus,
    buttonUse: buttonUse,
    className: className,
    onChange: onChange,
    options: statusOptions,
    readOnly: readOnly,
    ref: inputRef,
    value: value,
    disabled: disabled
  });
};
PropertyInputPaymentStatus.defaultProps = {
  buttonUse: 'form'
};
export default /*#__PURE__*/memo(PropertyInputPaymentStatus);